import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyTheClub from './components/WhyTheClub';
import FeaturedTreatments from './components/FeaturedTreatments';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-sand">
      <Navigation />
      <HeroSection />
      <WhyTheClub />
      <FeaturedTreatments />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </div>
  );
}